import { FC, PropsWithChildren, useMemo } from 'react';
import { notification } from 'antd';

import { Button } from '@/shared/components';
import { Row } from '@/shared/components/layout';

import { AntdNotificationsContext } from './AntdNotificationsContext';
import { NotificationsApi } from './types';

export const AntdNotificationsProvider: FC<PropsWithChildren> = ({ children }) => {
  const [notificationApi, notificationContext] = notification.useNotification();

  const antdNotifications = useMemo(() => {
    const value: NotificationsApi = {
      api: notificationApi,
      info: (message) => {
        notificationApi.info({ message, placement: 'bottom', duration: 5 });
      },
      error: (message) => {
        notificationApi.error({ message, placement: 'top' });
      },
      confirm: (message, onConfigm, key) => {
        const itemKey = key ?? String(Date.now());

        notificationApi.info({
          key: itemKey,
          message,
          placement: 'bottom',
          btn: (
            <Row direction={'row'} nowrap gapColumn={10}>
              <Button
                text="Yes"
                onClick={() => {
                  notificationApi.destroy(itemKey);
                  onConfigm();
                }}
              />
              <Button text="No" onClick={() => notificationApi.destroy(itemKey)} />
            </Row>
          ),
          duration: 0,
        });
      },
    };

    return value;
  }, [notificationApi]);

  return (
    <AntdNotificationsContext.Provider value={antdNotifications}>
      {notificationContext}
      {children}
    </AntdNotificationsContext.Provider>
  );
};
